export const LOGIN = 'LOGIN';
export const SIGNUP = 'SIGNUP';
export const HOME = 'Home';
export const BLOCK_EMAIL = 'Block Email';

//Staff
export const STAFF = 'TIB Staffs';
export const STAFF_SET_PASSOWRD = 'Staff Set Password';
export const FACTORY = 'Factory';

//User
export const USER = 'User Accounts';
export const USER_DETAIL = 'Customer';

//Template
export const TEMPLATE = 'Creative Shop';
export const CREATE_TEMPLATE = 'Create Template';
export const VIEW_REPORT = 'View Report';

//Code management
export const CODE_MANAGEMENT = 'Discount Codes';
export const CODE_CREATION = 'Create Code';

// Budget allocation
export const ALLOCATION = 'Budget Allocation';
export const EDIT_ALLOCATION = 'Budget Allocation';

// Campaign Management
export const CAMPAIGN_MANAGEMENT = 'Campaign Management';

// Partner Program
export const PARTNER_PROGRAM = 'Partner Program';
export const PROCESS_DIVIDEND_PAYOUTS = 'Payout Dividends';
